import { render, staticRenderFns } from "./exhibitor-visitor-recommendations.vue?vue&type=template&id=5608e558&scoped=true"
import script from "./exhibitor-visitor-recommendations.vue?vue&type=script&lang=js"
export * from "./exhibitor-visitor-recommendations.vue?vue&type=script&lang=js"
import style0 from "./exhibitor-visitor-recommendations.vue?vue&type=style&index=0&id=5608e558&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5608e558",
  null
  
)

export default component.exports